import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {OPTION_ITEM} from '../../services/option/option.service';


@Component({
  selector: 'app-option-item',
  templateUrl: './option-item.component.html',
  styleUrls: ['./option-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionItemComponent implements OnInit {
  @HostBinding('attr.class') cssClass = 'setting-box';
  @HostBinding('style.display') styleBlock = 'block';
  @Input() optionItem: OPTION_ITEM;
  @Input() closeBtn = false;
  @Output() onClose: EventEmitter<any>;

  constructor() {
    this.onClose = new EventEmitter<any>();
  }

  ngOnInit(): void {
  }

}
